import { render, staticRenderFns } from "./AppExpandTransition.vue?vue&type=template&id=3af8dc08&scoped=true"
import script from "./AppExpandTransition.vue?vue&type=script&lang=js"
export * from "./AppExpandTransition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af8dc08",
  null
  
)

export default component.exports